import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import Api from 'services/Api'
import BaseModal from 'components/Modals/BaseModal'
import { Button } from 'components/Forms'
import { ConfirmationStatus, ShiftHistory } from 'components/Schedule'
import { Loading, Tabs } from 'components/UI'
import { Format } from 'services/Dates'
import { convertFromRuleString } from 'services/schedule/RecurrenceRules'
import { closeModal } from 'store/actions/modals'
import { Alert } from 'ui'

import { t } from 'translations'

const ScheduleHistoryModal = ({ _id }) => {
  const dispatch = useDispatch()
  const [event, setEvent] = useState()
  const [eventDeleted, setEventDeleted] = useState(false)

  useEffect(() => {
    const fetchOldEvent = async () => {
      const { result, success } = await Api.get('schedule/schedule', { params: { _id, useNewReturn: true } })
      if (!success || !result.length) return setEventDeleted(true)
      const { start, end, rrule, ...rest } = result[0]

      setEvent({
        ...rest,
        startDate: Format(start, { outFormat: 'date' }),
        start: Format(start, { outFormat: 'serverTime' }),
        end: Format(end, { outFormat: 'serverTime' }),
        rrule: convertFromRuleString(rrule, { defaultUntil: Format(start, { outFormat: 'date' }) })
      })
    }

    if (_id !== 'new') fetchOldEvent()
  }, [_id])

  const getModalContent = () => {
    if (!event && !eventDeleted) return <Loading />

    if (eventDeleted)
      return (
        <div className="pt-2 pb-3 px-3">
          <Alert variant="warning">{t('manager.schedule.EDIT_MODAL.EVENT_DELETED')}</Alert>
          <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
        </div>
      )

    if (event.finalized)
      return (
        <div className="pt-2 pb-3 px-3">
          <Alert variant="warning">{t('manager.schedule.EDIT_MODAL.EVENT_FINALIZED')}</Alert>
          <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
        </div>
      )

    return (
      <Tabs
        module="manager.schedule.EDIT_MODAL"
        tabs={[
          {
            name: 'confirmation',
            component: (
              <div className="pt-2 px-3 pb-3">
                {' '}
                <ConfirmationStatus _id={_id} />
              </div>
            )
          },
          {
            name: 'history',
            component: (
              <div className="p-3">
                <ShiftHistory diffs={event.diffs} />
              </div>
            )
          }
        ]}
      />
    )
  }

  return <BaseModal title={`manager.schedule.HISTORY_MODAL`}>{getModalContent()}</BaseModal>
}

export default ScheduleHistoryModal
